<div
  class="alert-curtain"
  [ngClass]="{ alertActive: active }"
  (click)="onBackdropClick()"
>
  <section (click)="$event.stopPropagation()">
    <a *ngIf="!isProcessing" (click)="done(undefined)()">
      <svg viewBox="0 0 12 12">
        <path
          fill-rule="evenodd"
          d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
        />
      </svg>
    </a>

    <h4>{{ alertObject.title }}</h4>

    <p *ngIf="!isProcessing" [innerHtml]="alertObject.message"></p>

    <div *ngIf="isProcessing" class="progress-area">
      <div class="progress-spinner" aria-hidden="true"></div>
      <p
        class="progress-message"
        [class.message-visible]="messageVisible"
      >
        {{ displayMessage }}<span class="loading-dots" aria-hidden="true"
          ><span>.</span><span>.</span><span>.</span></span
        >
      </p>
    </div>

    <ul *ngIf="alertObject.options && !isProcessing" class="options">
      <li *ngFor="let option of alertObject.options">
        <input
          type="checkbox"
          [(ngModel)]="option.selected"
          [ngModelOptions]="{ standalone: true }"
        />
        <span (click)="option.selected = !option.selected">{{
          option.displayName
        }}</span>
      </li>
    </ul>
    <ng-container *ngIf="!isProcessing">
      <p
        *ngFor="let text of alertObject.bottomTexts"
        [ngStyle]="text.styleObj"
        [innerHTML]="text.textHtml"
      ></p>
    </ng-container>
    <ng-container *ngIf="!isProcessing">
      <ichannel-button
        *ngFor="let button of alertObject.buttons"
        [label]="button.title"
        [theme]="button.theme || 'DARK'"
        [callback]="done(button.callback, button)"
        [clickable]="!button.disabled"
      ></ichannel-button>
    </ng-container>
  </section>
</div>
